goog.provide("shadow.js.shim.module$src$svg$type$thumbnails$youtube_bumper_svg$default");
shadow.js.shim.module$src$svg$type$thumbnails$youtube_bumper_svg$default = shadow.js.shim.module$src$svg$type$thumbnails$youtube_bumper_svg.default;
